import { render, staticRenderFns } from "./Proforma-Invoice.vue?vue&type=template&id=6731457e"
import script from "./Proforma-Invoice.vue?vue&type=script&lang=js"
export * from "./Proforma-Invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports